import React from 'react';
import H2 from '@teetsh/app/src/components/Typography/Headings/H2';
import tw from 'twin.macro';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

interface Props {
  disabled?: boolean;
  success?: boolean;
  className?: string;
  children?: React.ReactNode;
  step: number;
}

export function Title(props: Props) {
  const { children, className, disabled, success, step } = props;

  return (
    <H2
      className={className}
      css={[
        disabled && !success && tw`text-neutral-moderate`,
        tw`flex items-center`,
      ]}
    >
      {success ? (
        <CheckCircleIcon tw="h-6 w-6 mr-2 text-neutral-moderate" />
      ) : (
        `${step}. `
      )}
      {children}
    </H2>
  );
}
